import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../models/error.model';
import { IPagingInfoWithOrder } from '../../../../../models/paginationInfo.model';
import { IMainApiService, IPagedResult } from '../../../../../services/api.service';
import { IApiService } from '../../../../../services/api.service.base';
import { IProjectActivity } from '../projectDetailsActivities.models';

export interface IProjectDetailsActivitiesApiService {
  getProjectActivitiesAsync(request: IGetProjectActivitiesRequest): Promise<IPagedResult<IProjectActivity<never>> | ACDLError>;
}

export namespace IProjectDetailsActivitiesApiService {
  export const $: interfaces.ServiceIdentifier<IProjectDetailsActivitiesApiService> = Symbol('PROJECT_DETAILS_ACTIVITIES_API_SERVICE');
}

interface IGetProjectActivitiesRequest extends IPagingInfoWithOrder {
  projectId: string;
  activities: string[];
  actor: string;
}

@injectable()
export class ProjectDetailsActivitiesApiService implements IProjectDetailsActivitiesApiService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  async getProjectActivitiesAsync(request: IGetProjectActivitiesRequest): Promise<IPagedResult<IProjectActivity<never>> | ACDLError> {
    return await this.apiService.postAsync<IPagedResult<IProjectActivity<never>>>('/Projects/activities', request);
  }
}
